<script setup lang="ts">
const { modal } = defineProps<{
  isMenuOpen: boolean
  items: any[]
  modal: any
}>()

const emit = defineEmits(['update:isMenuOpen'])

const isModalOpen = ref(false)
const route = useRoute()
const product = ref('')

const products = modal[0]?.fields?.find((field: FieldContent) => field?.name === 'product')?.options

getInitialProduct()

watch(() => route.path, () => getInitialProduct())

function getInitialProduct() {
  product.value = products?.find((product: any) => route.path.includes(product.code))?.code
}
</script>

<template>
  <div>
    <div class="max-w-[1260px] mx-auto flex px-2 font-poppins xl:px-0 gap-2 items-center h-15 xl:h-20">
      <ModalContactMe v-model="isModalOpen" v-bind="modal[0]" v-model:initial-product="product" />
      <NuxtLink to="/" class="!bg-transparent" @click="emit('update:isMenuOpen', false)">
        <img class="w-130px lg:w-180px" src="@/assets/logo.png" alt="porovnej24 logo">
      </NuxtLink>
      <div class="flex py-auto gap-4 sm:gap-8 items-center ml-auto flex-row">
        <div class="flex items-center gap-2">
          <a href="tel:810 800 080">
            <AppIcon size="24" icon="fal-phone-alt" class="text-gray-special-light" />
          </a>
          <span class="font-bold text-primary hidden lg:inline">810 800 080</span>
          <BaseButton
            size="small" render="primary" class="hidden sm:inline bg-secondary-active text-white"
            @click.prevent="isModalOpen = true"
          >
            Zavolejte mi
          </BaseButton>
        </div>
        <div class="lg:px-8 lg:border-x-1">
          <a href="mailto:info@porovnej24.cz" class="flex gap-2 text-secondary-active hover:underline">
            <AppIcon size="24" icon="fal-envelope" class="text-gray-special-light" />
            <span class="text-normal hidden md:inline">info@porovnej24.cz</span>
          </a>
        </div>
      </div>
      <TheNavigationHamburger
        class="text-gray-special-light lg:hidden" :open="isMenuOpen"
        @click="$emit('update:isMenuOpen', !isMenuOpen)"
      />
    </div>

    <nav class="bg-primary text-white font-poppins <lg:hidden xl:flex">
      <div class="max-w-[1288px] mx-auto flex items-center h-12 xl:h-14">
        <NuxtLink class="flex items-center <lg:hidden h-full p-5" to="/" @click="emit('update:isMenuOpen', false)">
          <AppIcon size="20" icon="fal-home-alt" class="lg:hover:text-gray-special" />
        </NuxtLink>
        <div class="hidden lg:flex lg:py-0 lg:h-full" :class="{ isMenuOpen }">
          <TheNavigationMenu :items="items" @is-menu-open="emit('update:isMenuOpen', false)" />
        </div>
      </div>
    </nav>

    <nav class="bg-gray-special text-white font-poppins hidden" :class="{ isMenuOpen }">
      <TheNavigationMenu :items="items" @is-menu-open="emit('update:isMenuOpen', false)" />
    </nav>
  </div>
</template>

<style lang="scss" scoped>
.isMenuOpen {
  @screen <lg {
    @apply left-0 top-[60px] absolute flex flex-col z-50 bg-primary w-full
  }
}

.router-link-active {
  @apply text-primary bg-white pointer-events-none
}
</style>
